import AnswerOptions from 'src/features/restocking/components/RestockingWebAppForm/components/AnswerOptions/AnswerOptions'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'

const ForkliftQuestionPage: React.FC = () => (
  <Page
    headerTitle='Reposição'
    goBackRoute='/restocking/webapp/badge'
    propertyToClear='hasForkliftAuth'
  >
    <AnswerOptions
      text='Possui habilitação para o uso de empilhadeira?'
      property='hasForkliftAuth'
      nextPage='/restocking/webapp/list-selection'
      firstButtonProps={
        {
          color: 'confirm',
          hoverColor: 'confirmHover',
          text: 'Sim',
          value: true,
          testid: 'button-yes-forklift-restocking-test-id',
        }
      }
      secondButtonProps={
        {
          color: 'cancel',
          hoverColor: 'cancelHover',
          text: 'Não',
          value: false,
          testid: 'button-no-forklift-restocking-test-id',
        }
      }
    />
  </Page>
)

export default ForkliftQuestionPage
